import { jsx as o } from "react/jsx-runtime";
import * as d from "react";
import { cva as l } from "class-variance-authority";
import { cn as t } from "../../../lib/utils.js";
const n = l("rounded-2xl overflow-hidden transition-all duration-500 font-sans", {
  variants: {
    variant: {
      default: "bg-surface backdrop-blur-md border border-border-color shadow-luxury hover:shadow-premium hover:-translate-y-0.5",
      glass: "bg-surface/10 backdrop-blur-[24px] border border-border-color rounded-2xl shadow-[0_8px_32px_rgba(0,0,0,0.08)] hover:bg-surface/15 transition-all duration-500",
      elevated: "bg-bg-surface border-none shadow-premium hover:shadow-floating hover:-translate-y-1",
      v4: "bg-v4-card-bg border border-v4-card-border rounded-2xl shadow-v4-card p-6 hover:shadow-v4-hover hover:-translate-y-0.5 transition-all duration-300",
      "v4-dark": "bg-gradient-to-br from-lpr-navy via-lpr-blue to-[#1E2A38] rounded-2xl text-white p-6 shadow-luxury transition-all duration-300"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), i = d.forwardRef(({ className: r, variant: a, ...e }, s) => o("div", { ref: s, className: t(n({ variant: a }), r), ...e }));
i.displayName = "Card";
const b = d.forwardRef(({ className: r, ...a }, e) => o("div", { ref: e, className: t("flex flex-col space-y-1.5 p-5 border-b border-border-color bg-bg-muted/10 backdrop-blur-sm", r), ...a }));
b.displayName = "CardHeader";
const f = d.forwardRef(({ className: r, ...a }, e) => o("h3", { ref: e, className: t("text-sm font-semibold text-text-primary", r), ...a }));
f.displayName = "CardTitle";
const c = d.forwardRef(({ className: r, ...a }, e) => o("p", { ref: e, className: t("text-xs text-text-secondary mt-1", r), ...a }));
c.displayName = "CardDescription";
const m = d.forwardRef(({ className: r, ...a }, e) => o("div", { ref: e, className: t("p-5", r), ...a }));
m.displayName = "CardContent";
const p = d.forwardRef(({ className: r, ...a }, e) => o("div", { ref: e, className: t("flex items-center justify-end gap-3 border-t border-border-color p-4 bg-bg-muted/10", r), ...a }));
p.displayName = "CardFooter";
export {
  i as Card,
  m as CardContent,
  c as CardDescription,
  p as CardFooter,
  b as CardHeader,
  f as CardTitle
};
//# sourceMappingURL=Card.js.map
